import { render, staticRenderFns } from "./TemplateUser.vue?vue&type=template&id=65d6aa2a&scoped=true"
import script from "./TemplateUser.vue?vue&type=script&lang=js"
export * from "./TemplateUser.vue?vue&type=script&lang=js"
import style0 from "./TemplateUser.vue?vue&type=style&index=0&id=65d6aa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d6aa2a",
  null
  
)

export default component.exports